<template>
  <!-- <section>
    <p>{{ $route.query.p }}</p>
  </section> -->
  <div>
    <template v-if="this.s_msg != ''">
      <CCard border-color="info">
        <CCardBody>
          <p class="text-info">{{ this.s_msg }}</p>
        </CCardBody>
      </CCard>
    </template>
    <template v-if="this.msg != ''">
      <CCard border-color="danger">
        <CCardBody>
          <p class="text-danger">{{ this.msg }}</p>
        </CCardBody>
      </CCard>
    </template>
    <template
      v-if="
        $route.query.p == 'i' &&
        (this.responseStatus == '200' || this.responseStatus == '')
      "
    >
      <CCard>
        <CCardBody>
          <!-- <CSelect
            prepend="店舗/学校/病院名"
            class="col-sm-8"
            :options="selectList"
            :value.sync="$v.targetShop.$model"
            :isValid="checkSelect('targetShop')"
            :disabled="isLoading"
            :placeholder="selectInfo"
            invalidFeedback="必須項目です。対象の店舗/学校/病院名を選択してください。"
          /> -->
          <div role="group" class="col-sm-12 d-inline-block form-group">
            <div class="input-group">
              <div class="input-group-prepend" style="height: 31.4px">
                <span class="input-group-text">{{ $t('店舗/学校/病院名') }}</span>
              </div>
              <!-- <div class="form-control"> -->
              <v-select
                class="col-sm-7 style-chooser"
                style="padding-left: 0; vertical-align: middle"
                :options="selectList"
                v-model="$v.targetShop.$model"
                :isValid="checkSelect('targetShop')"
                :disabled="isLoading"
                :placeholder="selectInfo"
              >
                <span slot="no-options">{{ $t('検索候補がありません') }}</span>
              </v-select>
              <!-- </div> -->
            </div>
          </div>

          <CSelect
            :prepend="$t('表示形式')"
            class="col-sm-9"
            :options="selectType"
            :value.sync="$v.targetType.$model"
            :isValid="checkSelect('targetType')"
            :placeholder="selectInfo2"
            :invalidFeedback="$t('必須項目です。表示形式を選択してください。')"
          />
          <CButton
            @click="searchData()"
            color="success"
            :disabled="$v.targetType.$invalid || $v.targetShop.$invalid"
            class="d-inline-block mb-1 ml-2"
          >
            {{ $t('検索') }}
          </CButton>
          <CButton @click="moveShopPage()" color="secondary" class="ml-5">
            {{ $t('一覧に戻る') }}
          </CButton>
        </CCardBody>
      </CCard>
    </template>
    <!-- グラフ埋め込み情報 -->
    <template v-if="this.showEditErea == true">
      <CCard>
        <CCardBody>
          <template header>
            <h5 class="modal-title font-weight-bold mb-2">
              {{ $t('グラフ埋め込み情報') }}
            </h5>
          </template>
          <CInput
            :prepend="$t('埋め込みID')"
            v-model="this.requestParam.embeddedId"
            disabled
          />
          <CInput
            :prepend="$t('店舗/学校/病院名')"
            v-model="this.requestParam.shopName"
            disabled
          />
          <!-- <CInput
            prepend="表示形式"
            v-model="this.requestParam.displayType"
            disabled
          /> -->
          <CInput
            :prepend="$t('表示形式')"
            v-model="this.requestParam.displayTypeName"
            disabled
          />
          <!-- <CInput
            prepend="登録名"
            v-model="this.requestParam.registerName"
            
        /> -->
          <CInput
            :prepend="$t('登録名')"
            :lazy="false"
            :value.sync="$v.requestParam.registerName.$model"
            :isValid="checkIfValidModal('registerName')"
            :invalidFeedback="$t('必須項目です。140文字以内で入力してください。')"
          />
          <div>
            <h6 class="modal-title font-weight-bold mb-2">{{ $t('公開設定') }}</h6>
            <input
              type="radio"
              name="publishFlag"
              v-model="requestParam.publishFlag"
              value="1"
            />{{ $t('公開する') }}
            <input
              class="ml-4"
              type="radio"
              name="publishFlag"
              v-model="requestParam.publishFlag"
              value="0"
            />{{ $t('非公開にする') }}
          </div>
          <br />
          <div>
            <h6 class="modal-title font-weight-bold mb-2">{{ $t('端末一覧') }}</h6>
          </div>
          <CDataTable
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="fields"
            :noItemsView="loadingTable"
            :loading="isLoading"
          >
            <template #chk-pub="{ item }">
              <td>
                <input
                  class=""
                  type="checkbox"
                  :value="item.sensorId"
                  :id="item.sensorId"
                  @change="checkSensor()"
                  v-model="selected"
                />
              </td>
            </template>
          </CDataTable>
          <template v-if="this.msg2 != ''">
            <p class="text-danger">{{ this.msg2 }}</p>
          </template>
          <div>
            <h6 class="modal-title font-weight-bold mb-2">
              {{ $t('※ 表示対象のセンサーID（表示順で表示）') }}
            </h6>
            <ul>
              <li v-for="dt in this.selected">
                {{ dt }}
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h6 class="modal-title font-weight-bold mb-2">{{ $t('表示項目') }}</h6>
          </div>
          <template v-if="this.msg3 != ''">
            <p class="text-danger">{{ this.msg3 }}</p>
          </template>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="co2Concentration"
              @change="checkOpenData()"
              v-model="co2Concentration"
            />
            <label class="form-check-label" for="co2Concentration">
              {{ $t('CO2濃度を公開する') }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="temperature"
              @change="checkOpenData()"
              v-model="temperature"
            />
            <label class="form-check-label" for="temperature">
              {{ $t('室温を公開する') }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="humidity"
              @change="checkOpenData()"
              v-model="humidity"
            />
            <label class="form-check-label" for="humidity">
              {{ $t('湿度を公開する') }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="noise"
              @change="checkOpenData()"
              v-model="noise"
            />
            <label class="form-check-label" for="noise"> {{ $t('騒音を公開する') }} </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="bluetooth"
              @change="checkOpenData()"
              v-model="bluetooth"
            />
            <label class="form-check-label" for="bluetooth">
              {{ $t('混雑指数を公開する') }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="wbgt"
              @change="checkOpenData()"
              v-model="wbgt"
            />
            <label class="form-check-label" for="wbgt">
              {{ $t('暑さ指数を公開する') }}
            </label>
          </div>
          <br />
          <div>
            <h6 class="modal-title font-weight-bold mb-2">
              {{ $t('埋め込み設定 表示カラー') }}
            </h6>
            <input
              type="radio"
              name="displayColor"
              v-model="requestParam.displayColor"
              value="light"
            />{{ $t('ライト') }}
            <input
              class="ml-4"
              type="radio"
              name="displayColor"
              v-model="requestParam.displayColor"
              value="dark"
            />{{ $t('ダーク') }}
          </div>
          <br />
          <div><p class="text-danger">
            <b>{{ $t('公開対象のセンサーには、アラート設定をすることを推奨します。') }}</b><br/>
            {{ $t('アラート設定：指定した基準値を15分以上超えた場合、アラート通知先に対して通知が送信されます。') }}<br/>
            {{ $t('設定方法は、「センサー登録」の公開設定にて、基準値及び通知項目の指定、「店舗/学校/病院情報管理」の「アラート通知設定」にて通知方法、通知先の設定が出来ます。') }}
          </p></div>
          <br />
          <template v-if="this.msg != ''">
            <CCard border-color="danger">
              <CCardBody>
                <p class="text-danger">{{ this.msg }}</p>
              </CCardBody>
            </CCard>
          </template>
          <template v-if="!submitted && $route.query.p == 'u'">
            <CButton
              :disabled="!isValidModal || submitted"
              :color="editColor"
              @click="updateInfo"
            >
              {{ $t('更新') }}
            </CButton>
          </template>
          <template v-if="!submitted && $route.query.p == 'i'">
            <CButton
              :disabled="!isValidModal || submitted"
              :color="registerColor"
              @click="updateInfo"
            >
              {{ $t('登録') }}
            </CButton>
          </template>
          <template v-if="$route.query.p == 'u'">
            <CButton :color="editColor" class="ml-5" @click="openPrevPage()">
              {{ $t('コード表示/プレビュー') }}
            </CButton>
          </template>
          <CButton @click="moveShopPage()" color="secondary" class="ml-5">
            {{ $t('一覧に戻る') }}
          </CButton>
        </CCardBody>
      </CCard>
    </template>
  </div>
</template>
<script>
import validatorUtils from "./validatorUtils";
import { required, maxLength } from "vuelidate/lib/validators";
import { API } from "aws-amplify";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import CCheckUserPosition from "@/components/common/CCheckUserPosition.vue";

export default {
  name: "EmbeddedInfo",
  extends: CCheckUserPosition,
  components: {
    vSelect,
  },
  data() {
    // const registMessage = "埋め込み情報が登録されました。";
    const label_responsive =
      this.$i18n.tc('横幅可変(300px以上）、複数種類センサー、単一場所（端末）');
    const label_sensors =
      this.$i18n.tc('横幅可変(200px～300px）、単一種類センサー、複数場所（端末）');
    const label_minimum =
      this.$i18n.tc('縦横幅固定(300px×250px)、2種類センサー、単一場所（端末）');
    const ret_sunccess = 0;
    const ret_error = 1;
    const editColor = "success";
    const registerColor = 'info'
    return {
      selected: [],
      ret_sunccess,
      ret_error,
      editColor,
      registerColor,
      showEditErea: false,
      responseStatus: "",
      isLoading: false,
      submitted: false,
      // registMessage,
      dialogClasses: ["modal-max-width"],
      selectInfo2: this.$i18n.tc('表示形式を選択してください'),
      selectInfo: this.$i18n.tc('店舗/学校/病院名を選択してください。'),
      detailModal: false,
      msg: "",
      msg2: "",
      msg3: "",
      s_msg: "",
      items: [],
      items_sensors: [],
      items_embed_sensors: [],
      embeddedId: "",
      shopName: "",
      displayType: "",
      registerName: "",
      requestParam: {
        embeddedId: "",
        facilityId: "",
        sectionId: "",
        shopName: "",
        displayType: "",
        displayTypeName: "",
        registerName: "",
        publishFlag: "",
        co2Concentration: "",
        temperature: "",
        humidity: "",
        noise: "",
        bluetooth: "",
        wbgt: "",
        displayColor: "",
        // checkedSensors: [],
      },
      loadingTable: {
        noItems: "",
      },
      shopList: [],
      selectList: [
        {
          value: "",
          label: "",
        },
      ],
      targetShop: "",
      targetType: "",
      selectType: [
        // minimum
        // responsive
        // sensors
        { value: "responsive", label: label_responsive },
        { value: "sensors", label: label_sensors },
        { value: "minimum", label: label_minimum },
      ],
      ngSensorsMap: new Map(),
      label_responsive,
      label_sensors,
      label_minimum,
      co2Concentration: "",
      temperature: "",
      humidity: "",
      noise: "",
      bluetooth: "",
      wbgt: "",
    };
  },
  props: {
    fields: {
      type: Array,
      default() {
        // 公開/非公開					代表センサー					センサー名					センサーID

        return [
          { key: "chk-pub", label: "" },
          { key: "publishFlagLabel", label: this.$i18n.tc('公開/非公開') },
          { key: "mainSensorFlagLabel", label: this.$i18n.tc('代表センサー') },
          { key: "sensorName", label: this.$i18n.tc('センサー名') },
          { key: "sensorId", label: this.$i18n.tc('センサーID') },
        ];
      },
    },
    hover: Boolean,
    striped: {
      type: Boolean,
      default() {
        return true;
      },
    },
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    clickEdit: Function,
  },
  mixins: [validatorUtils],
  validations: {
    targetShop: {
      required,
    },
    targetType: {
      required,
    },
    registerName: {
      required,
      maxLength: maxLength(140),
    },
    requestParam: {
      registerName: {
        required,
        maxLength: maxLength(140),
      },
    },
  },
  methods: {
    async searchData() {
      this.initializeRequestParam();
      this.showEditErea = true;
      this.isLoading = true;
      this.loadingTable.noItems = "Loading";
      // var tmp = this.targetShop.split(":", 2);
      var tmp = this.targetShop.value.split(":", 2);
      var facilityId = tmp[0];
      var sectionId = tmp[1];
      // var shopName = this.targetShop.replace(
      //   facilityId + ":" + sectionId + ":",
      //   ""
      // );
      var shopName = this.targetShop.value.replace(
        facilityId + ":" + sectionId + ":",
        ""
      );

      this.items = [];
      this.items_sensors = [];
      this.items_embed_sensors = [];
      this.msg = "";
      this.msg2 = "";
      this.msg3 = "";
      let api_param = "";
      let srid = this.getLoginUserPositionIdInStorage();
      if( srid != null ){
        api_param = "?resellerId=" + srid;
      } 
      var url =
        "/facilities/" + facilityId + "/shops/" + sectionId + "/sensors" + api_param;
      await this.getSensors(url);
      console.log("searchData here1:" + this.items_sensors.length);
      if (this.items_sensors.length > 0) {
        this.items = this.items_sensors;
      }

      this.requestParam.facilityId = facilityId;
      this.requestParam.sectionId = sectionId;
      this.requestParam.shopName = shopName;
      this.requestParam.displayType = this.targetType;
      this.requestParam.displayTypeName = this.changeDisplayTypeLabel(
        this.requestParam.displayType
      );
      this.requestParam.publishFlag = "1";
      this.requestParam.displayColor = "light";
    },
    getSensors(url) {
      return new Promise((resolve) => {
        console.log("getSensors start");
        API.get("BuildingPOC", url, {
          headers: {
            "x-api-key": this.config.xApiKey,
            Authorization: this.getIdTokenFromStorage(),
          },
          response: true,
        })
          .then((res) => {
            if (res.status != "200") {
              if (res.status == "204") {
                this.msg =
                  this.$i18n.tc('HTML出力可能なセンサーIDが見つかりません。センサー登録画面にて公開を行ってください。');
              } else {
                this.msg = this.$i18n.tc('apimessage.'+res.data.messageCode);
              }
              this.items_sensors = [];
              this.loadingTable.noItems = "No items";
              this.isLoading = false;
            } else {
              this.items_sensors = res.data.items;
              if (
                this.items_sensors == null ||
                this.items_sensors.length == 0
              ) {
                this.loadingTable.noItems = "No items";
                this.msg =
                  this.$i18n.tc('HTML出力可能なセンサーIDが見つかりません。センサー登録画面にて公開を行ってください。');
              }
              this.items_sensors = this.changeSensorsItem(
                this.items_sensors,
                false
              );
              console.log("getSensors:" + this.items_sensors.length);
              this.isLoading = false;
            }
            console.log("getSensors return success");
            resolve(this.ret_sunccess);
          })
          .catch((err) => {
            this.loadingTable.noItems = "No items";
            this.isLoading = false;
            console.log(err);
            this.msg = this.$i18n.tc('apimessage.'+err.response.data.messageCode);
            this.items = [];
            console.log(this.msg);
            resolve(this.ret_error);
          });
        console.log("getSensors end.");
        // return this.ret_sunccess;
      });
    },
    changeSensorsItem(s_items, b) {
      console.log("changeSensorsItem start");
      for (let i = 0; i < s_items.length; i++) {
        if (s_items[i].publishFlag == "1") {
          s_items[i].publishFlagLabel = this.$i18n.tc('公開');
        } else if (s_items[i].publishFlag == "0") {
          s_items[i].publishFlagLabel = this.$i18n.tc('非公開');
        } else {
          s_items[i].publishFlagLabel = this.$i18n.tc('削除');
        }
        if (s_items[i].mainSensorFlag == "1") {
          s_items[i].mainSensorFlagLabel = "〇";
        } else {
          s_items[i].mainSensorFlagLabel = "";
        }
        // s_items[i].checked = b;
        if (b) {
          this.selected[i] = s_items[i].sensorId;
        }

        if (s_items[i].publishFlag != "1") {
          this.ngSensorsMap.set(s_items[i].sensorId, s_items[i].sensorId);
        }
      }
      console.log("changeSensorsItem end");
      return s_items;
    },
    getEmbeddedInfo(route) {
      return new Promise((resolve) => {
        console.log("getEmbeddedInfo start");
        var getUrl =
          "/facilities/" +
          route.params.facilityId +
          "/shops/" +
          route.params.sectionId +
          "/embedded/" +
          route.params.embeddedId;

        this.initializeRequestParam();
        API.get("BuildingPOC", getUrl, {
          headers: {
            "x-api-key": this.config.xApiKey,
            Authorization: this.getIdTokenFromStorage(),
          },
          response: true,
        })
          .then((res) => {
            if (res.status != "200") {
              this.msg = this.$i18n.tc('apimessage.'+res.data.messageCode);
              resolve(this.ret_error);
            } else {
              this.requestParam.embeddedId = res.data.items.embeddedId;
              this.requestParam.facilityId = res.data.items.facilityId;
              this.requestParam.sectionId = res.data.items.sectionId;
              this.requestParam.shopName = res.data.items.shopName;
              this.requestParam.displayType = res.data.items.displayType;
              this.requestParam.registerName = res.data.items.registerName;

              this.requestParam.displayTypeName = this.changeDisplayTypeLabel(
                this.requestParam.displayType
              );
              this.requestParam.publishFlag = res.data.items.publishFlag;
              this.requestParam.displayColor = res.data.items.displayColor;

              if (res.data.items.co2Concentration == "1") {
                this.co2Concentration = true;
              } else {
                this.co2Concentration = false;
              }
              if (res.data.items.temperature == "1") {
                this.temperature = true;
              } else {
                this.temperature = false;
              }
              if (res.data.items.humidity == "1") {
                this.humidity = true;
              } else {
                this.humidity = false;
              }
              if (res.data.items.noise == "1") {
                this.noise = true;
              } else {
                this.noise = false;
              }
              if (res.data.items.bluetooth == "1") {
                this.bluetooth = true;
              } else {
                this.bluetooth = false;
              }
              if (res.data.items.wbgt == "1") {
                this.wbgt = true;
              } else {
                this.wbgt = false;
              }

              this.items_embed_sensors = res.data.items.sensorList;
              this.items_embed_sensors = this.changeSensorsItem(
                this.items_embed_sensors,
                true
              );
              console.log("getEmbeddedInfo:" + this.items_embed_sensors.length);
              console.log("getEmbeddedInfo_selected:" + this.selected);
              resolve(this.ret_sunccess);
            }
          })
          .catch((err) => {
            console.log(err);
            this.msg = this.$i18n.tc('apimessage.'+err.response.data.messageCode);
            resolve(this.ret_error);
          });
        console.log("getEmbeddedInfo end");
        // return this.ret_sunccess;
      });
    },
    changeDisplayTypeLabel(displayType) {
      var label = "";
      if (displayType == "responsive") {
        label = this.label_responsive;
      } else if (displayType == "sensors") {
        label = this.label_sensors;
      } else if (displayType == "minimum") {
        label = this.label_minimum;
      }
      return label;
    },
    // 店舗情報一覧を取得する
    getShops() {
      this.responseStatus = "";
      this.shopList = [];
      this.selectList = [];
      let api_param = "";
      let srid = this.getLoginUserPositionIdInStorage();
      if( srid != null ){
        api_param = "?resellerId=" + srid;
      } 
      API.get("BuildingPOC", "/manageShops" + api_param, {
        headers: {
          "x-api-key": this.config.xApiKey,
          Authorization: this.getIdTokenFromStorage(),
        },
        response: true,
      })
        .then((res) => {
          if (res.status != "200") {
            this.shopList = [];
          } else {
            this.shopList = res.data.items;
            this.selectList = [];
            this.selectInfo = this.$i18n.tc('店舗/学校/病院名を選択してください。');
            if (this.shopList == null || this.shopList.length == 0) {
              return;
            } else {
              for (var i = 0; i < this.shopList.length; i++) {
                if (
                  this.shopList[i].shopName == null ||
                  this.shopList[i].shopName == ""
                ) {
                  // 何もしない。スキップ
                } else {
                  this.selectList = [
                    ...this.selectList,
                    {
                      value:
                        this.shopList[i].facilityId +
                        ":" +
                        this.shopList[i].sectionId +
                        ":" +
                        this.shopList[i].shopName,
                      label: this.shopList[i].shopName,
                    },
                  ];
                }
              }
            }
            // this.isLoading =false
          }
        })
        .catch((err) => {
          console.log(err);
          this.msg = this.$i18n.tc('apimessage.'+err.response.data.messageCode);
          this.items = [];
          this.responseStatus = err.response.status;
          console.log(this.msg);
        });
    },
    // 表示項目のチェックボックスの入力チェック
    checkOpenData() {
      // this.msg = "";
      this.s_msg = "";
      this.msg3 = "";
      this.checkOpenData4common();
    },
    // 表示項目のチェックボックスの入力チェック
    checkOpenData4common() {
      let cnt = 0;
      // this.msg = "";
      if (this.co2Concentration) {
        cnt++;
      }
      if (this.temperature) {
        cnt++;
      }
      if (this.humidity) {
        cnt++;
      }
      if (this.noise) {
        cnt++;
      }
      if (this.bluetooth) {
        cnt++;
      }
      if (this.wbgt) {
        cnt++;
      }
      // minimum
      // responsive
      // sensors
      if (this.requestParam.displayType == "responsive") {
        // レスポンシブルの場合は1から5項目選択可能 -> 6項目に変更
        if (cnt >= 1 && cnt <= 6) {
          return this.ret_sunccess;
        } else {
          this.msg3 =
            this.$i18n.tc('選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～5個選択可能です。');
          return this.ret_error;
        }
      } else if (this.requestParam.displayType == "sensors") {
        // 複数センサーの場合は1項目のみ選択可能
        if (cnt == 1) {
          return this.ret_sunccess;
        } else {
          this.msg3 =
            this.$i18n.tc('選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１個選択可能です。');
          return this.ret_error;
        }
      } else if (this.requestParam.displayType == "minimum") {
        // ミニマム固定の場合は1から2項目選択可能
        if (cnt >= 1 && cnt <= 2) {
          return this.ret_sunccess;
        } else {
          this.msg3 =
            this.$i18n.tc('選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～２個選択可能です。');
          return this.ret_error;
        }
      } else {
        return this.ret_error;
      }
      // return this.ret_sunccess; // 到達しない
    },
    checkSensor() {
      // this.msg = "";
      this.msg2 = "";
      this.s_msg = "";
      this.checkSensor4com();
    },
    checkSensor4com() {
      for (let i = 0; i < this.selected.length; i++) {
        let sid = this.ngSensorsMap.get(this.selected[i]);
        if (sid == null || sid == "") {
          // 公開センサーを選択している
        } else {
          this.msg2 =
            this.$i18n.tc('「端末一覧」にて、非公開または削除されたセンサーIDが選択されています。現在公開されているセンサーIDを選択してください。対象：') +
            sid;
          return this.ret_error;
        }
      }

      if (this.selected.length == 0) {
        this.msg2 = this.$i18n.tc('「端末一覧」が未選択です。センサーIDを選択してください。');
        return this.ret_error;
      }
      if (this.requestParam.displayType == "sensors") {
        if (this.selected.length > 5) {
          this.msg2 =
            this.$i18n.tc('公開可能なセンサーは最大5個です。公開センサーを再選択してください。');
          return this.ret_error;
        }
      } else {
        if (this.selected.length > 1) {
          this.msg2 =
            this.$i18n.tc('選択した「表示形式」の場合、「端末一覧」で選択された個数は、指定できません。１個のみ選択可能です。');
          return this.ret_error;
        }
      }
      return this.ret_sunccess;
    },
    // 登録ボタン押下時に埋め込み情報を更新するための処理
    async updateInfo() {
      console.log("updateInfo:start");
      this.submitted = true;
      this.msg = "";
      this.msg2 = "";
      this.msg3 = "";
      this.s_msg = "";

      var ret1 = this.checkOpenData4common();
      var ret2 = this.checkSensor4com();

      let api_param = "";
      let srid = this.getLoginUserPositionIdInStorage();
      if( srid != null ){
        api_param = "?resellerId=" + srid;
      } 

      if (ret1 == this.ret_sunccess && ret2 == this.ret_sunccess) {
        console.log();
        if (this.$route.query.p == "u") {
          // '/facilities/{facilityId}/shops/{sectionId}/embedded/{embeddedId}'
          this.putData(
            "/facilities/" +
              this.requestParam.facilityId +
              "/shops/" +
              this.requestParam.sectionId +
              "/embedded/" +
              this.requestParam.embeddedId +
              api_param
          );
        } else {
          this.postData(
            "/facilities/" +
              this.requestParam.facilityId +
              "/shops/" +
              this.requestParam.sectionId +
              "/embedded" +
              api_param
          );
        }
      } else {
        // if(ret1 == this.ret_error){
        //   this.msg='表示形式と、公開する表示項目の数が合いません。表示項目を見直してください。';
        // }else if(ret2 == this.ret_error){
        //   this.msg='表示形式と、公開するセンサーの数が合いません。センサーの選択を見直してください。';
        // }
        this.submitted = false;
        console.log("error!");
      }
      // this.submitted = false;
      console.log("updateInfo:end");
    },
    changeCheckbox4Flag() {
      // チェックボックスのtrue/falseの値をJson用に1/0に変換
      if (this.co2Concentration) {
        this.requestParam.co2Concentration = "1";
      } else {
        this.requestParam.co2Concentration = "0";
      }
      if (this.temperature) {
        this.requestParam.temperature = "1";
      } else {
        this.requestParam.temperature = "0";
      }
      if (this.humidity) {
        this.requestParam.humidity = "1";
      } else {
        this.requestParam.humidity = "0";
      }
      if (this.noise) {
        this.requestParam.noise = "1";
      } else {
        this.requestParam.noise = "0";
      }
      if (this.bluetooth) {
        this.requestParam.bluetooth = "1";
      } else {
        this.requestParam.bluetooth = "0";
      }
      if (this.wbgt) {
        this.requestParam.wbgt = "1";
      } else {
        this.requestParam.wbgt = "0";
      }
      // if (this.requestParam.publishFlag) {
      //   this.requestParam.publishFlag = "1";
      // } else {
      //   this.requestParam.publishFlag = "0";
      // }
    },
    // 登録 or 更新後 に画面を再描画する処理
    movePageAfterDbupd() {
      // 名前付きルート
      console.log(
        "movePageAfterDbupd:" +
          this.requestParam.facilityId +
          ";" +
          this.requestParam.sectionId +
          ";" +
          this.requestParam.embeddedId +
          ";"
      );
      this.$router
        .push({
          name: "EmbeddedInfo",
          params: {
            facilityId: this.requestParam.facilityId,
            sectionId: this.requestParam.sectionId,
            embeddedId: this.requestParam.embeddedId,
          },
          query: { p: "u", ret: "s", t: Date.now() },
        })
        .catch((err) => err);
    },
    // 新規登録処理
    postData(postUrl) {
      console.log("postData:" + postUrl);
      console.log(
        " postData:" +
          this.requestParam.facilityId +
          "---" +
          this.requestParam.sectionId +
          "---" +
          this.requestParam.embeddedId
      );
      this.changeCheckbox4Flag();

      let s1 = "";
      let s2 = "";
      let s3 = "";
      let s4 = "";
      let s5 = "";
      for (let i = 0; i < this.selected.length; i++) {
        if (i == 0) {
          s1 = this.selected[i];
        } else if (i == 1) {
          s2 = this.selected[i];
        } else if (i == 2) {
          s3 = this.selected[i];
        } else if (i == 3) {
          s4 = this.selected[i];
        } else if (i == 4) {
          s5 = this.selected[i];
        }
      }
      API.post("BuildingPOC", postUrl, {
        headers: {
          "x-api-key": this.config.xApiKey,
          Authorization: this.getIdTokenFromStorage(),
        },
        response: true,
        body: {
          facilityId: this.requestParam.facilityId,
          sectionId: this.requestParam.sectionId,
          displayType: this.requestParam.displayType,
          registerName: this.requestParam.registerName,
          publishFlag: this.requestParam.publishFlag,
          co2Concentration: this.requestParam.co2Concentration,
          temperature: this.requestParam.temperature,
          noise: this.requestParam.noise,
          humidity: this.requestParam.humidity,
          bluetooth: this.requestParam.bluetooth,
          wbgt: this.requestParam.wbgt,
          displayColor: this.requestParam.displayColor,
          sensorId_1: s1,
          sensorId_2: s2,
          sensorId_3: s3,
          sensorId_4: s4,
          sensorId_5: s5,
        },
      })
        .then((res) => {
          this.s_msg = this.registerMessage;
          console.log("postData:sccess->" + res.data.message);
          this.requestParam.embeddedId = res.data.items.embeddedId;
          console.log("postData:end...");
          // return this.ret_sunccess;
          this.movePageAfterDbupd();
        })
        .catch((err) => {
          console.log("postData:error->" + err);
          console.log("postData:" + err);
          this.submitted = false;
          try {
            this.msg = this.$i18n.tc('apimessage.'+err.response.data.messageCode);
          } catch (e) {
            this.msg = this.$i18n.tc('データ更新時にエラーが発生しました。');
          }
          // return this.ret_error;
        });
      // return this.ret_sunccess;
    },
    // 更新処理
    putData(putUrl) {
      console.log("putData:" + putUrl);
      console.log(
        " putData:" +
          this.requestParam.facilityId +
          "---" +
          this.requestParam.sectionId +
          "---" +
          this.requestParam.embeddedId
      );
      this.changeCheckbox4Flag();
      let s1 = "";
      let s2 = "";
      let s3 = "";
      let s4 = "";
      let s5 = "";
      for (let i = 0; i < this.selected.length; i++) {
        if (i == 0) {
          s1 = this.selected[i];
        } else if (i == 1) {
          s2 = this.selected[i];
        } else if (i == 2) {
          s3 = this.selected[i];
        } else if (i == 3) {
          s4 = this.selected[i];
        } else if (i == 4) {
          s5 = this.selected[i];
        }
      }

      API.put("BuildingPOC", putUrl, {
        headers: {
          "x-api-key": this.config.xApiKey,
          Authorization: this.getIdTokenFromStorage(),
        },
        response: true,
        body: {
          facilityId: this.requestParam.facilityId,
          sectionId: this.requestParam.sectionId,
          embeddedId: this.requestParam.embeddedId,
          displayType: this.requestParam.displayType,
          registerName: this.requestParam.registerName,
          publishFlag: this.requestParam.publishFlag,
          co2Concentration: this.requestParam.co2Concentration,
          temperature: this.requestParam.temperature,
          noise: this.requestParam.noise,
          humidity: this.requestParam.humidity,
          bluetooth: this.requestParam.bluetooth,
          wbgt: this.requestParam.wbgt,
          displayColor: this.requestParam.displayColor,
          sensorId_1: s1,
          sensorId_2: s2,
          sensorId_3: s3,
          sensorId_4: s4,
          sensorId_5: s5,
        },
      })
        .then((res) => {
          // this.msg = this.editMessage;
          this.movePageAfterDbupd();
          // return this.ret_sunccess;
        })
        .catch((err) => {
          console.log("putData:" + err);
          this.submitted = false;
          try {
            this.msg = this.$i18n.tc('apimessage.'+err.response.data.messageCode);
          } catch (e) {
            this.msg = this.$i18n.tc('データ更新時にエラーが発生しました。');
          }
          // return this.ret_error;
        });
      // return this.ret_sunccess;
    },
    initializeRequestParam() {
      this.requestParam = {
        embeddedId: "",
        facilityId: "",
        sectionId: "",
        shopName: "",
        displayType: "",
        displayTypeName: "",
        registerName: "",
        publishFlag: "",
        co2Concentration: "",
        temperature: "",
        humidity: "",
        noise: "",
        bluetooth: "",
        wbgt: "",
        displayColor: "",
      };
      this.co2Concentration = false;
      this.temperature = false;
      this.humidity = false;
      this.noise = false;
      this.bluetooth = false;
      this.wbgt = false;
      this.ngSensorsMap.clear(); // mapの初期化
      this.items = [];
      this.items_sensors = [];
      this.items_embed_sensors = [];
      this.submitted = false;
      this.selected = [];
      this.$v.$reset();
    },
    checkSelect(fieldName) {
      if (!this.$v[fieldName].$dirty) {
        return null;
      }
    },
    async getBaseInfo(route) {
      console.log("getBaseInfo :start");
      this.showEditErea = false;
      if (route.query.p == "i") {
        this.initializeRequestParam();
        this.isLoading = false;
        // this.embeddedId = "";
        // this.shopName = "";
        // this.displayType = "";
        // this.registerName = "";
      } else {
        this.showEditErea = true;
        this.isLoading = true;
        // this.embeddedId = "";
        // this.shopName = "";
        // this.displayType = "";
        // this.registerName = "";
        // 埋め込み情報を取得
        var ret1 = this.getEmbeddedInfo(route);
        // センサー一覧を取得
        let api_param = "";
        let srid = this.getLoginUserPositionIdInStorage();
        if( srid != null ){
          api_param = "?resellerId=" + srid;
        } 
        var getUrl =
          "/facilities/" +
          route.params.facilityId +
          "/shops/" +
          route.params.sectionId +
          "/sensors" + api_param;
        var ret2 = this.getSensors(getUrl);
        if (
          (await ret1) == this.ret_sunccess &&
          (await ret2) == this.ret_sunccess
        ) {
          // if (this.items_sensors.length == 0) {
          //   this.msg =
          //     "公開可能なセンサーが見つかりません。センサーを登録・公開してください。";
          // }
          const result = this.items_embed_sensors.concat(this.items_sensors);
          // リストマージ
          this.items = result.filter(
            (element, index, self) =>
              self.findIndex((e) => e.sensorId === element.sensorId) === index
          );
        } else {
          this.msg = this.$i18n.tc('データ取得時にエラーが発生しました。');
        }
      }
      this.isLoading = false;
      console.log("getBaseInfo :end");
    },
    // 公開可能かチェックする
    checkOpen() {
      // 処理なし
    },
    moveShopPage() {
      this.$router.push({ name: "Embed" });
    },
    // コード表示/プレビュー
    openPrevPage() {
      // path: 'displayEmbeddedCode/:facilityId/:sectionId/:embeddedId/',
      console.log(
        "displayEmbeddedCode:" +
          this.requestParam.facilityId +
          "---" +
          this.requestParam.sectionId +
          "---" +
          this.requestParam.embeddedId
      );
      const infoPage =
        "/displayEmbeddedCode/" +
        this.requestParam.facilityId +
        "/" +
        this.requestParam.sectionId +
        "/" +
        this.requestParam.embeddedId +
        "/"
        + '?l=' + this.$i18n.locale;
      window.open(infoPage, "_blank");
    },
    initView(route) {
      this.getBaseInfo(route);
      this.items = [];
      if (route.query.p == "i") {
        this.getShops();
      } else {
        if (route.query.ret == "s") {
          this.s_msg = this.$i18n.tc('グラフ埋め込み情報が登録されました。');
        }
      }
    },
    // checkIfValid(fieldName) {
    //   const field = this.requestParam[fieldName];
    //   // console.log('checkIfValid:'+fieldName+'='+field);
    //   if (!field.$dirty) {
    //     return null;
    //   }
    //   return !(field.$invalid || field.$model === "");
    // },
    checkIfValidModal(fieldName) {
      const field = this.$v.requestParam[fieldName];
      // console.log('checkIfValidModal:'+fieldName+'='+field.$model);
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    submit() {
      if (this.isValid) {
      // if (this.isValidModal) {
        this.submitted = true;
      }
    },
    validate() {
      this.$v.$touch();
    },
  },
  computed: {
    isValid() {
      return !this.requestParam.$invalid;
    },
    // isValid () { return !this.$v.$invalid },
    isValidModal() {
      return !this.$v.requestParam.$invalid;
    },
    isDirty() {
      return this.requestParam.$anyDirty;
    },
  },
  async created() {
    console.log("created do.");
    let ret = await this.checkLoginPosition("Embed");
    if ( ret ) {
      this.msg = this.$i18n.tc(ret);
      this.loadingTable.noItems = "No items";
      this.isLoading = false;
    } else {
      this.initView(this.$route);
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate do.");
    this.initView(to);
    next();
  },
};
</script>
<style scoped lang="scss">
// 子コンポーネントの要素にスタイルを適用するために /deep/ を指定
/deep/ .modal-max-width .modal-dialog {
  max-width: 50%;
}
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>